import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { HeroSectionB } from '../components/HeroSectionB';
import { SignalSection } from '../components/SignalSection';
import { AnticipationSection } from '../components/AnticipationSection';
import { DifferenceSection } from '../components/DifferenceSection';
import { PainSection } from '../components/PainSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { ProtocolSection } from '../components/ProtocolSection';
import { ForWhoSection } from '../components/ForWhoSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { BibliotecaSection } from '../components/BibliotecaSection';
import { OfferSection } from '../components/OfferSection';
import { AboutSection } from '../components/AboutSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTASection } from '../components/FinalCTASection';
const getVariant = (): string => {
  if (typeof window === 'undefined') return 'a';
  return new URLSearchParams(window.location.search).get('v') ?? 'a';
};
export function LandingPage() {
  const variant = getVariant();
  return <main className="overflow-hidden bg-background text-foreground min-h-screen font-body" data-id="element-346">

      {/* Test A/B: solo el hero cambia */}
      {variant === 'b' ? <HeroSectionB data-id="element-347" /> : <HeroSection data-id="element-348" />}

      {/* Concepto 2: Señal con reveal secuencial */}
      <SignalSection data-id="element-349" />

      {/* Concepto 3: Anticipación — el destino antes del vehículo */}
      <AnticipationSection data-id="element-350" />

      {/* Concepto 4: Protocolo con journey bar + fases interactivas */}
      <ProtocolSection data-id="element-351" />

      <BenefitsSection data-id="element-352" />
      <PainSection data-id="element-353" />
      <TestimonialsSection data-id="element-354" />
      <ForWhoSection data-id="element-355" />
      <BibliotecaSection data-id="element-356" />

      {/* Antes/Después + cierre de identidad — justo antes del CTA */}
      <DifferenceSection data-id="element-357" />

      <OfferSection data-id="element-358" />
      <AboutSection data-id="element-359" />
      <FAQSection data-id="element-360" />
      <FinalCTASection data-id="element-361" />

    </main>;
}